<div class="max-w-[1920px] mx-auto">
  <div class="base-page-container">
    <div class="page-header">
      <div class="title" [wunEditableText]="'artist_home.header.title'" [fallback]="fallbacks.header.title"></div>
      <div class="sub-title" [wunEditableText]="'artist_home.header.subtitle'" [fallback]="fallbacks.header.subtitle"></div>
    </div>

    <div class="py-12">
      <button (click)="scrollToElement(formDivElement)" wunButton primary class="!px-16" [wunEditableText]="'artist_home.joinButton'" [fallback]="fallbacks.joinButton"></button>
    </div>

    <div class="max-h-96 flex items-center overflow-hidden relative mb-20">
      <img src="assets/image/wundart-carousel-home.png" alt="Wundart Banner" class="w-full" />
      <div class="absolute h-full w-full flex items-center justify-center">
        <div class="bg-black flex p-3 gap-5 md:p-10 md:px-24 md:gap-36">
          <div class="text-white">
            <div class="text-md md:text-2xl font-thin" [wunEditableText]="'artist_home.trial.offer'" [fallback]="fallbacks.trial.offer"></div>
            <div class="text-lg md:text-3xl" [wunEditableText]="'artist_home.trial.days'" [fallback]="fallbacks.trial.days"></div>
          </div>
          <div class="flex items-center">
            <button wunButton
              class="bg-white text-center px-2 py-1 md:px-6 md:py-2 hover:bg-gray-200 transition-colors cursor-pointer"
              (click)="scrollToElement(step1)"
              [wunEditableText]="'artist_home.trial.tryButton'"
              [fallback]="fallbacks.trial.tryButton"></button>

          </div>
        </div>
      </div>
    </div>

    <div class="box-header" [wunEditableText]="'artist_home.whyJoin.title'" [fallback]="fallbacks.whyJoin.title"></div>

    <div class="grid grid-cols-1 md:grid-cols-2 w-full xl:grid-cols-4 lg:grid-cols-2 gap-8 mt-8">
      <!-- ARTIST -->
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'artist_home.whyJoin.features.0.title'" [fallback]="fallbacks.whyJoin.features[0].title"></div>
        <div class="box-content" [wunEditableText]="'artist_home.whyJoin.features.0.content'" [fallback]="fallbacks.whyJoin.features[0].content"></div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'artist_home.whyJoin.features.1.title'" [fallback]="fallbacks.whyJoin.features[1].title"></div>
        <div class="box-content" [wunEditableText]="'artist_home.whyJoin.features.1.content'" [fallback]="fallbacks.whyJoin.features[1].content"></div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'artist_home.whyJoin.features.2.title'" [fallback]="fallbacks.whyJoin.features[2].title"></div>
        <div class="box-content" [wunEditableText]="'artist_home.whyJoin.features.2.content'" [fallback]="fallbacks.whyJoin.features[2].content"></div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'artist_home.whyJoin.features.3.title'" [fallback]="fallbacks.whyJoin.features[3].title"></div>
        <div class="box-content" [wunEditableText]="'artist_home.whyJoin.features.3.content'" [fallback]="fallbacks.whyJoin.features[3].content"></div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'artist_home.whyJoin.features.4.title'" [fallback]="fallbacks.whyJoin.features[4].title"></div>
        <div class="box-content" [wunEditableText]="'artist_home.whyJoin.features.4.content'" [fallback]="fallbacks.whyJoin.features[4].content"></div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'artist_home.whyJoin.features.5.title'" [fallback]="fallbacks.whyJoin.features[5].title"></div>
        <div class="box-content" [wunEditableText]="'artist_home.whyJoin.features.5.content'" [fallback]="fallbacks.whyJoin.features[5].content"></div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'artist_home.whyJoin.features.6.title'" [fallback]="fallbacks.whyJoin.features[6].title"></div>
        <div class="box-content" [wunEditableText]="'artist_home.whyJoin.features.6.content'" [fallback]="fallbacks.whyJoin.features[6].content"></div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'artist_home.whyJoin.features.7.title'" [fallback]="fallbacks.whyJoin.features[7].title"></div>
        <div class="box-content" [wunEditableText]="'artist_home.whyJoin.features.7.content'" [fallback]="fallbacks.whyJoin.features[7].content"></div>
      </div>
    </div>


    <div class="w-full p-10 text-center flex justify-center">
      <button wunButton primary class="!px-16" (click)="scrollToElement(formDivElement)" [wunEditableText]="'artist_home.joinButton'" [fallback]="fallbacks.joinButton"></button>
    </div>

  </div>

  <div class="bg-black w-full p-8 md:p-12">
    <div class="max-w-[1200px] mx-auto flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-10">
      <div class="font-thin text-white text-xl md:text-3xl lg:text-4xl text-center lg:text-left" [wunEditableText]="'artist_home.questions.title'" [fallback]="fallbacks.questions.title"></div>
      <div class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer"
          (click)="scrollToElement(faqContainer)" [wunEditableText]="'artist_home.questions.faqButton'" [fallback]="fallbacks.questions.faqButton"></a>
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
          routerLink="/exchange-refund-policy" [wunEditableText]="'artist_home.questions.exchangePolicy'" [fallback]="fallbacks.questions.exchangePolicy"></a>
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
          routerLink="/artist-experience" [wunEditableText]="'artist_home.questions.artistExperience'" [fallback]="fallbacks.questions.artistExperience"></a>
      </div>
    </div>
  </div>

  <div class="base-page-container">
    <div class="box-header pb-10" [wunEditableText]="'artist_home.plans.title'" [fallback]="fallbacks.plans.title"></div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 font-thin">
      <div class="bg-wundart-gray-box p-5">
        <div class="plan-box">
          <div class="plan-title text-2xl text-center" [wunEditableText]="'artist_home.plans.monthly.title'" [fallback]="fallbacks.plans.monthly.title"></div>
          <div class="plan-price text-4xl p-10 text-center" [wunEditableText]="'artist_home.plans.monthly.price'" [fallback]="fallbacks.plans.monthly.price"></div>
          <div class="plan-price text-4xl text-center">
            <span [wunEditableText]="'artist_home.plans.monthly.goldMembership'" class="mr-2" [fallback]="fallbacks.plans.monthly.goldMembership"></span>
            <span [wunEditableText]="'artist_home.plans.monthly.goldPrice'" [fallback]="fallbacks.plans.monthly.goldPrice"></span>
          </div>
        </div>
      </div>
      <div class="bg-wundart-gray-box p-5">
        <div class="plan-box">
          <div class="plan-title text-2xl text-center" [wunEditableText]="'artist_home.plans.trimester.title'" [fallback]="fallbacks.plans.trimester.title"></div>
          <div class="plan-price text-4xl p-10 text-center" [wunEditableText]="'artist_home.plans.trimester.price'" [fallback]="fallbacks.plans.trimester.price"></div>
          <div class="plan-price text-4xl text-center">
            <span [wunEditableText]="'artist_home.plans.trimester.goldMembership'" class="mr-2" [fallback]="fallbacks.plans.trimester.goldMembership"></span>
            <span [wunEditableText]="'artist_home.plans.trimester.goldPrice'" [fallback]="fallbacks.plans.trimester.goldPrice"></span>
          </div>
        </div>
      </div>
      <div class="bg-wundart-gray-box p-5">
        <div class="plan-box">
          <div class="plan-title text-2xl text-center" [wunEditableText]="'artist_home.plans.annual.title'" [fallback]="fallbacks.plans.annual.title"></div>
          <div class="plan-price text-4xl p-10 text-center" [wunEditableText]="'artist_home.plans.annual.price'" [fallback]="fallbacks.plans.annual.price"></div>
         <div class="plan-price text-4xl text-center">
            <span [wunEditableText]="'artist_home.plans.annual.goldMembership'" class="mr-2" [fallback]="fallbacks.plans.annual.goldMembership"></span>
            <span [wunEditableText]="'artist_home.plans.annual.goldPrice'" [fallback]="fallbacks.plans.annual.goldPrice"></span>
          </div>
        </div>
      </div>
    </div>


<div class="relative mt-20 h-[680px] sm:h-[680px] md:h-[612px] w-full" #step1>

  <!-- Background Image -->
  <img 
    src="assets/image/wundart-carousel-home.png" 
    alt="Wundart Banner"
    class="absolute inset-0 w-full h-full object-cover"
  />

  <!-- Overlay -->
  <div class="absolute inset-0 flex items-center justify-center">

    <div class="bg-black/85 flex p-4 md:p-16 flex-col gap-8 max-w-6xl">

      <!-- Title -->
      <div class="text-white text-center md:text-left">
        <div class="text-sm md:text-2xl font-thin" [wunEditableText]="'artist_home.steps.offer'" [fallback]="fallbacks.steps.offer"></div>
        <div class="text-lg md:text-3xl" [wunEditableText]="'artist_home.steps.trial'" [fallback]="fallbacks.steps.trial"></div>
      </div>

      <!-- Steps -->
      <div class="text-white flex flex-col md:flex-row gap-6 md:gap-8 font-thin items-center">

        <!-- Step 1 -->
        <div class="max-w-60 flex flex-col gap-2 text-center md:text-left">
          <div class="text-lg" [wunEditableText]="'artist_home.steps.apply.title'" [fallback]="fallbacks.steps.apply.title"></div>
          <div [wunEditableText]="'artist_home.steps.apply.description'" [fallback]="fallbacks.steps.apply.description"></div>
        </div>

        <!-- Arrow -->
        <div class="hidden md:block">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="1.5" stroke="currentColor" class="size-8">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
          </svg>
        </div>

        <!-- Step 2 -->
        <div class="max-w-60 flex flex-col gap-2 text-center md:text-left">
          <div class="text-lg" [wunEditableText]="'artist_home.steps.approved.title'" [fallback]="fallbacks.steps.approved.title"></div>
          <div [wunEditableText]="'artist_home.steps.approved.description'" [fallback]="fallbacks.steps.approved.description"></div>
        </div>

        <!-- Arrow -->
        <div class="hidden md:block">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="1.5" stroke="currentColor" class="size-8">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
          </svg>
        </div>

        <!-- Step 3 -->
        <div class="max-w-60 flex flex-col gap-2 text-center md:text-left">
          <div class="text-lg" [wunEditableText]="'artist_home.steps.days.title'" [fallback]="fallbacks.steps.days.title"></div>
          <div [wunEditableText]="'artist_home.steps.days.description'" [fallback]="fallbacks.steps.days.description"></div>
        </div>

      </div>

      <!-- CTA -->
      <div class="flex justify-center w-full">
        <button
          wunButton
          class="bg-white text-black text-center px-4 py-2 md:px-6 md:py-2 hover:bg-gray-200 transition-colors cursor-pointer"
          (click)="scrollToElement(formDivElement)"
          [wunEditableText]="'artist_home.steps.tryButton'"
          [fallback]="fallbacks.steps.tryButton"></button>
      </div>

    </div>

  </div>

</div>

    <div class="box-header text-xl py-8" #formDivElement [wunEditableText]="'artist_home.applyNow.title'" [fallback]="fallbacks.applyNow.title"></div>

    <div class="text-xl font-thin">
      <span [wunEditableText]="'artist_home.applyNow.description'" [fallback]="fallbacks.applyNow.description"></span>
      <br />
      <span [wunEditableText]="'artist_home.applyNow.descriptionLine2'" [fallback]="fallbacks.applyNow.descriptionLine2"></span>
    </div>

    <div class="mt-14">
      <form [formGroup]="signupForm" class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[800px] m-auto">
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black [placeholder]="fallbacks.form.name" formControlName="firstName">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black [placeholder]="fallbacks.form.surname" formControlName="lastName">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black [placeholder]="fallbacks.form.email" type="email" formControlName="email">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black [placeholder]="fallbacks.form.phone" formControlName="phone">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black [placeholder]="fallbacks.form.country" formControlName="country">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black [placeholder]="fallbacks.form.city" formControlName="city">
        </div>

        <div wunInputContainer class="col-span-2">
          <label class="pl-3" [wunEditableText]="'artist_home.form.youAre'" [fallback]="fallbacks.form.youAre"></label>
          <select required formControlName="typeOfArtist" class="h-[34px]" wunInput black>
            <option value="none">{{'common.select' | transloco}}</option>
            <option value="Beginner" [wunEditableText]="'artist_home.form.beginner'" [fallback]="fallbacks.form.beginner"></option>
            <option value="Established" [wunEditableText]="'artist_home.form.established'" [fallback]="fallbacks.form.established"></option>
          </select>
        </div>
        <div wunInputContainer class="col-span-2">
          <label class="text-black pl-3" [wunEditableText]="'artist_home.form.socialMediaLabel'" [fallback]="fallbacks.form.socialMediaLabel"></label>
          <input wunInput black formControlName="socialMediaLinks">
        </div>
        <div class="col-span-2 pl-3 flex gap-10 items-center">
          <label [wunEditableText]="'artist_home.form.uploadPortfolio'" [fallback]="fallbacks.form.uploadPortfolio"></label>
          <div>
            <wun-file-uploader #fileUploader [isImg]="false" [accept]="'application/pdf'" [required]="true">
              <ng-template #triggerElement let-trigger="trigger">
                <div class="flex gap-3 items-center">
                <button (click)="trigger()" wunButton primary [wunEditableText]="'artist_home.form.selectFile'" [fallback]="fallbacks.form.selectFile"></button>
                {{ fileUploader.currentMedia()?.name }}
                </div>

              </ng-template>
            </wun-file-uploader>
          </div>
        </div>
        <div wunInputContainer class="col-span-2">
          <label class="text-black pl-3" [wunEditableText]="'artist_home.form.galleriesLabel'" [fallback]="fallbacks.form.galleriesLabel"></label>
          <input wunInput black placeholder="" formControlName="galleries">
        </div>
        <!-- <div wunInputContainer class="col-span-2">
          <label class="text-black pl-3" [wunEditableText]="'artist_home.form.exhibitionsLabel'" [fallback]="fallbacks.form.exhibitionsLabel"></label>
          <input wunInput black placeholder="" formControlName="exhibitions">
        </div> -->
        <div wunInputContainer class="col-span-2">
          <input wunInput black [placeholder]="fallbacks.form.nickname" formControlName="username">
        </div>
        <div wunInputContainer class="col-span-2">
          <label class="text-black pl-3" [wunEditableText]="'artist_home.form.galleryCodeLabel'" [fallback]="fallbacks.form.galleryCodeLabel"></label>
          <input wunInput black [placeholder]="fallbacks.form.galleryCodePlaceholder" formControlName="assignedToGallery">
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black [placeholder]="fallbacks.form.password" type="password" formControlName="password">
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black [placeholder]="fallbacks.form.confirmPassword" type="password" formControlName="confirmPassword">
        </div>
        <div class="col-span-2">
          <wun-checkbox formControlName="termsAndConditions"
            label="">
          
            <ng-template #label>
              <span [wunEditableText]="'artist_home.form.termsPrefix'" [fallback]="fallbacks.form.termsPrefix"></span>
              <a href="/terms-and-conditions.pdf" target="_blank" [wunEditableText]="'artist_home.form.termsLink'" [fallback]="fallbacks.form.termsLink"></a>
              <span [wunEditableText]="'artist_home.form.termsAnd'" [fallback]="fallbacks.form.termsAnd"></span>
              <a href="/privacy-policy.pdf" target="_blank" [wunEditableText]="'artist_home.form.privacyLink'" [fallback]="fallbacks.form.privacyLink"></a>.
            </ng-template>
          </wun-checkbox>
        </div>

        <div class="py-6 w-full flex justify-center col-span-2">
          <button wunButton primary class="!px-16" type="submit" (click)="signup()" [wunEditableText]="'artist_home.form.send'" [fallback]="fallbacks.form.send"></button>
        </div>
      </form>
    </div>
  </div>

  <div class="bg-black w-full p-8 md:p-12" #faqContainer>
    <div class="max-w-[1200px] mx-auto flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-10">
      <div class="font-thin text-white text-xl md:text-3xl lg:text-4xl text-center lg:text-left" [wunEditableText]="'artist_home.questions.title'" [fallback]="fallbacks.questions.title"></div>
      <div class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded"
          (click)="scrollToElement(faqContainer)" [wunEditableText]="'artist_home.questions.faqButton'" [fallback]="fallbacks.questions.faqButton"></a>
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded whitespace-nowrap"
          routerLink="/exchange-refund-policy" [wunEditableText]="'artist_home.questions.exchangePolicy'" [fallback]="fallbacks.questions.exchangePolicy"></a>
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded whitespace-nowrap"
          routerLink="/artist-experience" [wunEditableText]="'artist_home.questions.artistExperience'" [fallback]="fallbacks.questions.artistExperience"></a>
      </div>
    </div>
  </div>

  <div class="base-page-container flex flex-col gap-4 max-w-[1510px] m-auto mt-10">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q1.question'" [fallback]="fallbacks.faq.q1.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-xs lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q1.intro'" [fallback]="fallbacks.faq.q1.intro"></p>

        <p class="font-medium mb-2">1. Apply & Subscribe</p>
        <ul class="list-disc pl-6 mb-4">
          <li>Submit your application through this link: Apply Now</li>
          <li>Our Admissions Committee will review your portfolio.</li>
          <li>Once accepted, choose the subscription plan that suits you best and unlock your artist account.</li>
        </ul>

        <p class="font-medium mb-2">For experienced artists:</p>
        <ul class="list-disc pl-6 mb-4">
          <li>If you already have existing experience you have to submit with the application form a list of all the
            galleries you have collaborated with, both past and present, and a list of exhibitions and art fairs you
            attended.</li>
        </ul>

        <p class="font-medium mb-2">For emerging artists:</p>
        <ul class="list-disc pl-6 mb-4">
          <li>If this is your first experience with the world of art sales you must undergo a quotation process of the
            artworks you upload by our team of qualified curators. Once your artworks will be quoted you can follow with
            your subscription and to the next step.</li>
        </ul>

        <p class="font-medium mb-2">2. Build Your Profile</p>
        <p class="mb-4">With the support of our Curators Team, you'll start shaping your profile — adding photos,
          personal details, and your artworks.</p>
        <p class="mb-4">Enhance your visibility by including additional images and personalized descriptions that
          capture the essence of your creations.</p>
        <p class="mb-4">This is your space to define how you present yourself, your art, and your creative world to a
          global audience.</p>

        <p class="font-medium mb-2">Process a Sale</p>
        <p class="mb-4">Our dedicated Art Advisors actively engage with collectors to showcase your work.</p>
        <p class="mb-4">When a buyer expresses interest, makes an offer, or requests more details or images, an Advisor
          will personally reach out to you to help finalize the sale and ensure a smooth transaction.</p>

        <p class="font-medium mb-2">Shipping & Logistics</p>
        <p class="mb-4">At Wundart we pride ourselves in collaborating with Mailboxes Etc., one of the leaders of the
          art shipping field.</p>
        <p class="mb-4">This collaboration ensures that the delivery process will be fully automated and in the hands of
          real professionals.</p>
        <p class="mb-4">Once a sale is confirmed, a representative from Mailboxes Etc. will contact you to guide you
          through every step of the shipping process. If you live in a larger center a courier will come directly at
          your address to make the parcel themselves, prepare the required documents, and subsequently take charge of
          the package.</p>
        <p class="mb-4"><strong>Please note:</strong> shipping costs are covered by the customer.</p>
        <p class="mb-4">You can freely choose — and update — the pickup address for your artwork at any time.</p>
        <p class="mb-4">The packaging service is only available in larger urban centres. If you live in a smaller center
          or more remote area you will be directly instructed by Mailboxes Etc. on how to handle the shipping.</p>

        <p class="font-medium mb-2">Payment</p>
        <p class="mb-4">You'll receive your payment 14 business days after the artwork is delivered to the customer.</p>
        <p class="mb-4">Transactions are processed securely via PayPal or bank transfer to the account specified in your
          artist profile.</p>

        <p class="font-medium mb-2">Continue to Grow Your Artistic Presence</p>
        <p class="mb-4">With Wundart's marketing initiatives, detailed performance insights on your audience, regular
          platform improvements, and continuous support from our Artist Care Team, you have everything you need to keep
          expanding your reach.</p>
        <p class="mb-4">Use these tools and resources to promote your art, refine your profile, and connect with an
          ever-growing global community of collectors and art lovers.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q2.question'" [fallback]="fallbacks.faq.q2.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="font-medium mb-2" [wunEditableText]="'artist_home.faq.q2.title'" [fallback]="fallbacks.faq.q2.title"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q2.content'" [fallback]="fallbacks.faq.q2.content"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q2.content2'" [fallback]="fallbacks.faq.q2.content2"></p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q3.question'" [fallback]="fallbacks.faq.q3.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q3.content'" [fallback]="fallbacks.faq.q3.content"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q3.content2'" [fallback]="fallbacks.faq.q3.content2"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q3.content3'" [fallback]="fallbacks.faq.q3.content3"></p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q4.question'" [fallback]="fallbacks.faq.q4.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="font-medium mb-2" [wunEditableText]="'artist_home.faq.q4.silverPlan'" [fallback]="fallbacks.faq.q4.silverPlan"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q4.silverContent'" [fallback]="fallbacks.faq.q4.silverContent"></p>
        <p class="font-medium mb-2" [wunEditableText]="'artist_home.faq.q4.goldPlan'" [fallback]="fallbacks.faq.q4.goldPlan"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q4.goldContent'" [fallback]="fallbacks.faq.q4.goldContent"></p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q5.question'" [fallback]="fallbacks.faq.q5.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q5.content'" [fallback]="fallbacks.faq.q5.content"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q5.content2'" [fallback]="fallbacks.faq.q5.content2"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q5.content3'" [fallback]="fallbacks.faq.q5.content3"></p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q6.question'" [fallback]="fallbacks.faq.q6.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q6.content'" [fallback]="fallbacks.faq.q6.content"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q6.content2'" [fallback]="fallbacks.faq.q6.content2"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q6.content3'" [fallback]="fallbacks.faq.q6.content3"></p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q7.question'" [fallback]="fallbacks.faq.q7.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q7.content'" [fallback]="fallbacks.faq.q7.content"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q7.content2'" [fallback]="fallbacks.faq.q7.content2"></p>
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q7.content3'" [fallback]="fallbacks.faq.q7.content3"></p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q8.question'" [fallback]="fallbacks.faq.q8.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q8.content'" [fallback]="fallbacks.faq.q8.content"></p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'artist_home.faq.q9.question'" [fallback]="fallbacks.faq.q9.question"></div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'artist_home.faq.q9.content'" [fallback]="fallbacks.faq.q9.content"></p>
      </div>
    </mat-expansion-panel>
    <newsletter-subscribe />

  </div>

</div>